import { useState } from 'react'

import { ClampingText } from '../../ClampingText'
import { Component, ComponentProps } from '../Component'
import { controls, number, text } from '../Controls'

import { CLAMPING_TEXT_FULL_TEXT } from './ClampingText.mocks'

export function ClampingTextCSSUsage() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(number('clampingLinesCount', 3))
      .add(text('fullText', CLAMPING_TEXT_FULL_TEXT))
  )

  function handleChange(nextValue) {
    setProps(currProps => currProps.setValue('value', nextValue))
  }

  return (
    <>
      <Component
        {...props.getValues()}
        Component={ClampingText}
        name='ClampingTextCSS'
        onChange={handleChange}
      />
      <ComponentProps
        name='ClampingTextCSS'
        value={props}
        onChange={setProps}
      />
    </>
  )
}
